// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBaE-ej74rBysxq-57EqKzhn6ZZJ1jumKc",
    authDomain: "zen-pensions.firebaseapp.com",
    projectId: "zen-pensions",
    storageBucket: "zen-pensions.appspot.com",
    messagingSenderId: "383410824139",
    appId: "1:383410824139:web:6a2b18aa84036747f8cc4e",
    measurementId: "G-CQF6D3HD84"
};

// Above config and setup done from dooleyailish@gmail.com firebase account

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const notifications = getMessaging(app)

export { notifications };

